import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IViewer } from "@models/entity-models";

@Kbo(CToken.Viewer)
export class Viewer extends UiObject implements IViewer {

    constructor(kom: KbObjectManager) {
        super(kom);
    }    
}
